import template from './uploadSettings.html';
import controller from './uploadSettings.controller';

let uploadSettingsComponent = {
  restrict: 'E',
  bindings: {
    isOneRosterApi: '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default uploadSettingsComponent;



// WEBPACK FOOTER //
// ./app/components/uploadSettings/uploadSettings.component.js